import { ISession, ITeamMember } from "../../../../models/session";

export const isSpecialSession = (sessionType: string) => {
    const specialSession = ["meal", "tiyul", "break", "shabbat", "prayer"];
    return specialSession.includes(sessionType?.toLowerCase());
}

export const filterValidClasses = (classes: any[]) => {
    return (classes || []).filter((cls: any) => cls !== null);
};

export const filterSessionsByUser = (sessions: ISession[], me: any) => {
    const userClasses: ISession[] = [];
    let isProgramTeam = false;

    sessions.forEach((session: ISession) => {
        const listIdsOfSessionTeams = getSessionTeamIds(session);

        isProgramTeam = isProgramTeam || listIdsOfSessionTeams.includes(me._id);
        const isProgramTeamForThisSession = listIdsOfSessionTeams.includes(me._id);

        if (isSessionAccessible(session, isProgramTeamForThisSession, me.classes)) {
            userClasses.push(session);
        }
    });

    return { userClasses, isProgramTeam };
};

const getSessionTeamIds = (session: ISession) => {
    return session.sessionTeam ?
        session.sessionTeam.map((sessionTeam: ITeamMember) => sessionTeam?.Name__r?.HN_UserId__c)
        : [];
};

const isSessionAccessible = (session: ISession, isProgramTeamForThisSession: boolean, classes = []) => {
    const { _id, sessionPrivacy } = session;
    return (
        isProgramTeamForThisSession ||
        ["Open", null].includes(sessionPrivacy) ||
        (classes.some((cls: any) => cls._id === _id) && sessionPrivacy === "Registered Only")
    );
};

export const userOwnsEvent = (event: any, me: any) => me?.events?.includes(event?._id);

export const groupKey = (session: ISession): string => {
    const { startDate, startTime, endTime, sessionType } = session;

    return isSpecialSession(sessionType)
        ? `special_${startDate}_${sessionType}_${startTime}`
        : `${startDate}_${startTime}_${endTime}`;
};

export const sortSessionsByOrder = (a: ISession, b: ISession): number => {
    if (a.order !== undefined && b.order !== undefined) {
        return a.order - b.order;
    }
    return 0;
};

export const sortGroupsByDateAndTime = (a: any, b: any): number => {
    const dateComparison = new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
    return dateComparison !== 0 ? dateComparison : a.startTime.localeCompare(b.startTime);
};